import { Link } from "react-router-dom";
import { LogoMark } from "@/components/app/Logo";

export const AuthShell = ({ title, subtitle, children, testid }) => (
  <div className="app-grain flex min-h-screen flex-col items-center justify-center px-5 py-10" data-testid={testid}>
    <Link to="/" className="mb-8 flex items-center gap-2 font-display text-xl font-extrabold tracking-tight" data-testid="auth-brand-link">
      <LogoMark className="h-9 w-9" /> Ciclo Certo
    </Link>
    <div className="rise w-full max-w-md rounded-2xl border border-slate-700/60 bg-slate-900/80 p-6 shadow-2xl backdrop-blur-xl sm:p-8">
      <h1 className="font-display text-3xl font-extrabold tracking-tight">{title}</h1>
      {subtitle && <p className="mt-2 text-sm text-slate-400">{subtitle}</p>}
      <div className="mt-6">{children}</div>
    </div>
  </div>
);

export const FormError = ({ error }) => (error
  ? <p className="rounded-lg border border-rose-500/40 bg-rose-500/10 px-3 py-2 text-sm text-rose-300" data-testid="auth-error">{error}</p>
  : null);

export const PASSWORD_HINT = "Mínimo de 8 caracteres, com letras e números.";
